import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import styles from './HomePage.module.scss';
import Arrow from '../../assets/arrow-down-circle-fill.svg';
import Badge from '@mui/material/Badge';
import EmojiComponent from "./EmojiComponent";
import { useAppSelector } from "../../hooks/hook";
const IndexesNavigator = ({ numberArray, scrollElement }) => {
    // const numberArray = useMemo(() => Array.from(numbers).sort((a, b) => a - b), [numbers]);     
    const [currentValue, setCurrentValue] = useState(numberArray[0]);
    const goToNext = () => {
        var _a;
        const currentIndex = numberArray.indexOf(currentValue);
        const nextIndex = (currentIndex + 1) % numberArray.length;
        const nextValue = numberArray[nextIndex];
        setCurrentValue(nextValue);
        (_a = scrollElement.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex({
            index: nextValue,
            align: 'center',
            behavior: 'smooth'
        });
    };
    const goToPrevious = () => {
        var _a;
        const currentIndex = numberArray.indexOf(currentValue);
        const prevIndex = (currentIndex - 1 + numberArray.length) % numberArray.length;
        const prevValue = numberArray[prevIndex];
        setCurrentValue(prevValue);
        (_a = scrollElement.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex({
            index: prevValue,
            align: 'center',
            behavior: 'smooth'
        });
    };
    useEffect(() => {
        var _a;
        if (numberArray.length) {
            const lastValue = numberArray[numberArray.length - 1];
            setCurrentValue(lastValue);
            (_a = scrollElement.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex({
                index: lastValue,
                align: 'center',
                behavior: 'auto'
            });
        }
    }, [numberArray, scrollElement]);
    const displayIndex = numberArray.length ? numberArray.indexOf(currentValue) + 1 : 0;
    return (_jsx("div", { children: _jsxs("div", { style: { display: 'flex', flexDirection: 'column', alignItems: 'center' }, children: [_jsx("div", { style: { transform: 'rotate(180deg)' }, onClick: goToPrevious, children: _jsx(Badge, { color: "primary", children: _jsx(Arrow, { cursor: 'pointer' }) }) }), _jsx("div", { children: _jsx(Badge, { badgeContent: displayIndex }) }), _jsx("div", { onClick: goToNext, children: _jsx(Badge, { color: "primary", children: _jsx(Arrow, { cursor: 'pointer' }) }) })] }) }));
};
const ScrollButton = ({ noRead, scrollElement }) => {
    const isAtBottom = useAppSelector(state => state.app.isAtBottomScroll);
    const scrollIndexes = useAppSelector(state => state.app.targetMessages);
    const handleClick = () => {
        var _a;
        (_a = scrollElement.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex({
            index: noRead.targetIndex,
            align: 'center',
            behavior: 'smooth'
        });
    };
    if (!scrollElement)
        return null;
    if (scrollIndexes.length) {
        return _jsx(IndexesNavigator, { numberArray: scrollIndexes, scrollElement: scrollElement });
    }
    if (isAtBottom)
        return null;
    return (_jsx("div", { onClick: handleClick, children: _jsx(Badge, { badgeContent: noRead.quantity, color: "primary", children: _jsx(Arrow, { cursor: 'pointer' }) }) }));
};
const AdvancedContent = ({ noRead, scrollElement }) => {
    const parentRef = useRef(null);
    const [height, setHeight] = useState(350);
    useEffect(() => {
        const handleResize = () => {
            if (parentRef.current) {
                setHeight(parentRef.current.clientHeight - 4);
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    //console.log('advanced content')
    return (_jsx(_Fragment, { children: _jsxs("div", { className: styles.contentWrapper__control, children: [_jsx("div", { className: styles.emojiControl, ref: parentRef, children: _jsx(EmojiComponent, { height: height }) }), _jsx("div", { className: styles.scrollControl, children: scrollElement && (_jsx(ScrollButton, { noRead: noRead, scrollElement: scrollElement })) })] }) }));
};
export default AdvancedContent;
